import { useForm, useController } from "react-hook-form";
import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import validator from "validator";
import AsyncSelect from "react-select/async";
import axios from "axios";
import { getGeneralTypes, postData, postDataResponse, postUploadDocument } from "./Services";
import { StyledSelect, InputContainer, InputWrapper, HeaderContainer, HeaderText, NoteField, GreyButton, RedButton, RightJustifyDiv, SubmitSpan, CenterJustifyDiv } from "./Style";
import { useMsal } from "@azure/msal-react";
//import { Grid, TextField, Button, Card, CardContent, CardHeader, Typography, InputLabel, MenuItem, FormControl, Select } from '@mui/material/';
import { Grid, TextField, Backdrop, Button, Card, CircularProgress, CardContent, CardHeader, Typography, InputLabel, MenuItem, FormControl, Select, Link } from '@mui/material/';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DownloadIcon from '@mui/icons-material/Download'
import ConfirmDialog from "./ConfirmDialog";

import { styled } from '@mui/material/styles';
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const ImportInvoiceForm = ({ onSave, Case = {} }) => {
  const [MatterID, setMatterID] = useState([]);
  const [DocTypeID, setDocTypeID] = useState([]);
  const [errorRequest, setErrorRequest] = useState(false);
  const [notes, setNotes] = useState('');
  const [selectedValueMatterID, setSelectedValueMatterID] = useState("");
  const [selectedValueDocType, setSelectedValueDocType] = useState("");
  const [selectedFiles, setSelectedFiles] = useState(null);
  const [selectedFilesReceipt, setSelectedFilesReceipt] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const { instance } = useMsal();
  const [isValid, setIsValid] = useState(false);
  const [hasFile, setHasFile] = useState(false);
  const [hasReceiptFile, setHasReceiptFile] = useState(false);
  const [steInvoiceText, setsteInvoiceText] = useState([]);
  //const [steReceiptFile, setsteReceiptFile] = useState({});
  const [steInvoiceID, setsteInvoiceID] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [dialogMessage, SetDialogMessage] = useState("");
  const [isUploading, setUploading] = useState(false);
  const [dialogDestUrl, setDialogDestUrl] = useState("");
  const [dialogReturnHome, setDialogReturnHome] = useState(false);

  //const { register, handleSubmit, watch, control } = useForm();
  //const [selectedValue, setSelectedValue] = useState("");
  //let watchID = watch("id");
  //const { field } = useController({ name: "MatterIDSelect", control });


  useEffect(() => {

    async function fetchInitialData(_email) {

      const currentAccount = instance.getActiveAccount();
      var body = {};
      if (currentAccount) {
        setUserEmail(currentAccount.username); //(currentAccount.username);
        body.email = currentAccount.username; //currentAccount.username;
      }
      const tokenRequest = {
        account: currentAccount, // This is an example - Select account based on your app's requirements
        scopes: ["User.Read"]
      }

      const matterIDResponse = await postDataResponse('/User/MatterList', body);  //await getMatterID(body.email);
      matterIDResponse.errors ? setErrorRequest(true) : setMatterID(matterIDResponse.data);

      //const DocTypeResponse = await getGeneralTypes('/Settings/DocumentTypes');
      //DocTypeResponse.errors ? setErrorRequest(true) : setDocTypeID(DocTypeResponse);
    }

    fetchInitialData();

    const timer = setTimeout(() => {
      setOpenDialog(true);
      setIsSuccess(false);
      SetDialogMessage("Current has expired. Please refresh the page or select Continue");
      setDialogDestUrl("ImportInvoice");
    }, 5 * 60 * 1000);
  }, [instance, userEmail]);

  const handleSelectChangeDocType = (event) => {
    setSelectedValueDocType(event.target.value);
  };

  const handleSelectChangeMatterID = (event) => {
    setSelectedValueMatterID(event.target.value);
  };

  const selectFile = (event) => {
    event.preventDefault();
    const reader = new FileReader()

    reader.readAsText(event.target.files[0]);
    reader.onload = function (e) {
      const res = reader.result.split('\r\n');

      setSelectedFiles(event.target.files);
      setHasFile(true);
      setsteInvoiceText(res);
    };


  }

  const selectFileReceipt = (event) => {
    //event.preventDefault();
    setHasReceiptFile(true);
    setSelectedFilesReceipt(event.target.files);
    //setsteReceiptFile(event.target.files);
  }

  const upload = async () => {
    const form = new FormData();
  }


  /*const handleSave = (formValues) => {
   
    const errors = validateData();
    if(Object.keys(errors).length)
    {
        setErrors(errors);
        return;
    }
 
    setErrors({});
   
    //console.log(selectedValue);
    //onSave(formValues);
  };*/

  async function handleSubmit(e) {
    e.preventDefault();
    setUploading(true);
    /*const errors = validateData();
    if(Object.keys(errors).length)
    {
        setErrors(errors);
        return;
    }*/

    //setErrors({});
    // Read the form data
    const form = e.target;
    const formData = new FormData(form);
    const formJson = Object.fromEntries(formData.entries());

    setIsSuccess(true);
    SetDialogMessage("Invoice was successfully Submitted");

    let _mID = formJson.MatterIDSelect;
    const _InvoiceText = steInvoiceText;

    let postInvoiceObject = {
      MatterID: _mID,
      email: userEmail,
      InvoiceData: steInvoiceText
    };

    /*let response = await postDataResponse('/Invoice/Submit/', postInvoiceObject);
    var _invoiceID = "";
    if (response.status == 200) {
      setIsSubmitted(true);
      setsteInvoiceID(response.data);
      _invoiceID = response.data;


    }
    else {
      setIsSubmitted(false);
    }*/
    var _invoiceID = "";
    setUploading(true);
    postDataResponse('/Invoice/Submit', postInvoiceObject).then((response) => {
      if (response.status !== 200 && response.status !== 201) {
        setIsSuccess(false);
        SetDialogMessage(response.data);
        setUploading(false);
        setOpenDialog(true);
      } else {
        setsteInvoiceID(response.data);
        _invoiceID = response.data;

        if (!selectedFilesReceipt) {
          setHasReceiptFile(false);
        }

        if (hasReceiptFile && selectedFilesReceipt.length > 0) {
          const selectedFile = selectedFilesReceipt[0];
          formData.append("file", selectedFile);
          let _fileName = selectedFile.name;

          postUploadDocument('/Invoice/Attach/Receipt/' + _invoiceID, formData).then((response) => {
            if (response.status !== 200 && response.status !== 201) {
              setIsSuccess(false);
              SetDialogMessage("An Error occured when attempting to append Receipt to invoice");
              setDialogDestUrl("ImportInvoice");
            }
          });
          setUploading(false);
          setOpenDialog(true);
        }
      }
    });
  };

  const handleCloseDialog = () => { setOpenDialog(false); };
  return (
    <form onSubmit={handleSubmit}>
      <div>
        <Card className="form-card">
          <CardHeader title="Submit Case Invoice" style={{ backgroundColor: "#8B0E04", color: "#fff" }} />
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <FormControl fullWidth margin="normal">
                  <InputLabel id="MatterIDSelectLbl">Matter ID</InputLabel>
                  <Select
                    labelId="MatterIDSelectLbl"
                    id="MatterIDSelect"
                    name="MatterIDSelect"
                    label="Matter ID"
                    value={selectedValueMatterID}
                    onChange={handleSelectChangeMatterID}
                    required
                  >
                    <MenuItem value="">Choose a Matter</MenuItem >
                    {MatterID !== null ? MatterID.map((value) => (
                      <MenuItem key={value.id} value={value.id}>
                        {"\"" + value.id + "\" - " + value.description + " - " + value.clientSort}
                      </MenuItem >
                    )) : <MenuItem ></MenuItem >}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={9}>
                <TextField
                  id="outlined-read-only-input"
                  label="Selected Invoice"

                  fullWidth
                  defaultValue="Please select a file"
                  value={selectedFiles && selectedFiles.length > 0 ? selectedFiles[0].name : "Please select a file"}
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={3} alignItems="stretch" style={{ display: "flex" }}>

                <Button component="label" variant="contained" style={{ backgroundColor: "rgb(207, 66, 64)" }} startIcon={<CloudUploadIcon />}
                  onChange={selectFile} fullWidth>
                  Upload Invoice
                  <VisuallyHiddenInput type="file" />
                </Button>
              </Grid>

              <Grid item xs={12} sm={9}>
                <TextField
                  id="outlined-read-only-input"
                  label="Attach Receipt"

                  fullWidth
                  defaultValue="Please select a file"
                  value={selectedFilesReceipt && selectedFilesReceipt.length > 0 ? selectedFilesReceipt[0].name : "Please select a file"}
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={3} alignItems="stretch" style={{ display: "flex" }}>

                <Button component="label" variant="contained" style={{ backgroundColor: "rgb(207, 66, 64)" }} startIcon={<CloudUploadIcon />}

                  onChange={selectFileReceipt} fullWidth>
                  Upload Receipt
                  <VisuallyHiddenInput type="file" />
                </Button>
              </Grid>
              <Grid item xs={12} sm={2}>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Link
                  href="/files/COSA.OCIT.Invoice.example.xlsx"
                  download="COSA.OCIT.Invoice.example.xlsx"
                  display="inline-flex"
                  alignItems="center"
                  gap={0.5}
                  sx={{ cursor: 'pointer' }}
                >
                  <DownloadIcon fontSize="small" />
                  Sample Invoice
                </Link>
              </Grid>

              <Grid item xs={12} sm={2}>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Link
                  href="/files/COSA.OCIT.Invoice.blank.xlsx"
                  download="COSA.OCIT.Invoice.blank.xlsx"
                  display="inline-flex"
                  alignItems="center"
                  gap={0.5}
                  sx={{ cursor: 'pointer' }}
                >
                  <DownloadIcon fontSize="small" />
                  Blank Invoice
                </Link>
              </Grid>
              <Grid item xs={12} sm={2}>
              </Grid>



              <Grid item xs={12} sm={6}>
                <Button type="submit" variant="contained" style={{ backgroundColor: "rgb(207, 66, 64)" }} fullWidth>Submit</Button>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Button type="reset" variant="contained" style={{ backgroundColor: "rgb(51, 51, 51)" }} fullWidth>Clear</Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <ConfirmDialog
          isOpen={openDialog}
          onClose={handleCloseDialog}
          isSuccess={isSuccess}
          message={dialogMessage}
          destination={dialogDestUrl}
          returnHome={dialogReturnHome}
        />
        <Backdrop
          sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
          open={isUploading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>



      {/*}    <div>
        <Card style={{ maxWidth: 1024, margin: "0 auto" }}>
          <CardHeader title="Submit Invoice" style={{ backgroundColor: "#3f50b5", color: "#fff" }} />
          <CardContent>

            <Grid container spacing={1}>
              <Grid item xs={12} sm={12}>
                <FormControl fullWidth margin="normal">
                  <InputLabel id="MatterIDSelectLbl">Matter ID</InputLabel>
                  <Select
                    labelId="MatterIDSelectLbl"
                    id="MatterIDSelect"
                    value={selectedValueMatterID}
                    label="Matter ID"
                    onChange={handleSelectChangeMatterID}
                    required
                  >
                    <MenuItem value="">Choose a Matter</MenuItem >
                    {MatterID !== null ? MatterID.map((value) => (
                      <MenuItem key={value.id} value={value.id}>
                        {"\"" + value.id + "\" - " + value.description + " - " + value.clientSort}
                      </MenuItem >
                    )) : <MenuItem ></MenuItem >}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <label htmlFor="btn-uploadInvoice">
                  <input
                    id="btn-uploadInvoice"
                    name="btn-uploadInvoice"
                    style={{ display: 'none' }}
                    type="file"
                    onChange={selectFile}
                    required />
                  <Button
                    className="btn-choose"
                    variant="outlined"
                    component="span">
                    Choose File
                  </Button>
                </label>
                <div className="file-name">
                  {selectedFiles && selectedFiles.length > 0 ? selectedFiles[0].name : null}
                </div>
                {!hasFile &&
                  <div>
                    <label htmlFor="btn-uploadInvoice">Invoice LEDES 1998B File</label>
                  </div>
                }
              </Grid>

              <Grid item xs={12} sm={6}>
                <Button type="submit" variant="contained" color="success" fullWidth>Submit</Button>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Button type="reset" variant="contained" color="error" onClick={ClearForm} fullWidth>Clear</Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
*/}
      {/*<div>
        <HeaderContainer>
          <Typography sx={{ flexGrow: 1 }}>
            <HeaderText><Typography variant="h6">Import Invoice</Typography></HeaderText>
          </Typography>
        </HeaderContainer>
        <InputContainer>
          <InputWrapper>
            <div>
              <label>Matter ID</label>
            </div>
            <div>
              <StyledSelect
                name="MatterIDSelect"
                value={selectedValueMatterID}
                onChange={handleSelectChangeMatterID}
                autoFocus
              >

                {MatterID !== null ? MatterID.map((value) => (
                  <option key={value.id} value={value.id}>
                    {"\"" + value.id + "\" - " + value.description + " - " + value.clientSort}
                  </option>
                )) : <option></option>}
              </StyledSelect>
            </div>
            <div>
              <label htmlFor="btn-uploadInvoice">
                <input
                  id="btn-uploadInvoice"
                  name="btn-uploadInvoice"
                  style={{ display: 'none' }}
                  type="file"
                  onChange={selectFile} />
                <Button
                  className="btn-choose"
                  variant="outlined"
                  component="span">
                  Choose File
                </Button>
              </label>
              <div className="file-name">
                {selectedFiles && selectedFiles.length > 0 ? selectedFiles[0].name : null}
              </div>
              {!hasFile &&
                <div>
                  <label htmlFor="btn-uploadInvoice">Invoice LEDES 1998B File</label>
                </div>
              }

            </div>


            <div>
              <label htmlFor="btn-uploadReceipts">
                <input
                  id="btn-uploadReceipts"
                  name="btn-uploadReceipts"
                  style={{ display: 'none' }}
                  type="file"
                  onChange={selectFileReceipt} />
                <Button
                  className="btn-choose"
                  variant="outlined"
                  component="span">
                  Choose Receipt File
                </Button>
              </label>
              <div className="file-name">
                {steReceiptFile && steReceiptFile.length > 0 ? steReceiptFile[0].name : null}
              </div>
              {!hasReceiptFile &&
                <div>
                  <label htmlFor="btn-uploadReceipts">Receipts(All receipts must be in a single PDF File)</label>
                </div>
              }

            </div>
            <CenterJustifyDiv>
              <GreyButton type="submit">Import Invoice</GreyButton>

            </CenterJustifyDiv>

            <RightJustifyDiv>
              {isSubmitted ? <SubmitSpan>Submitted Successfully!</SubmitSpan> : <span></span>}
            </RightJustifyDiv>

          </InputWrapper>
        </InputContainer>
      </div>*/}
    </form >
  );
};
export default ImportInvoiceForm;
